import { SettingLandingBannersAlliesInformationContainer } from "..";

export const SettingLandingBannersAlliesMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingBannersAlliesInformationContainer />
    </div>
  );
};
